import $ from 'jquery';

export default {

	init() {
    var btn = $('.js-scroll-top');

    btn.on('click', function(e) {
      e.preventDefault();
      $('html, body').animate({scrollTop:0}, '300');
    });

		// smooth scroll on hash links
		$(document).on('click', 'a[href^="#"]', function (event) {
			event.preventDefault();

			$('html, body').animate({
				scrollTop: $($.attr(this, 'href')).offset().top - 200
			}, 500);

			$($.attr(this, 'href')).focus();

		});

	}

};
